<template>
  <div
    v-if="hasFiveStepsTracking && deliveryMode && deliveryMode != 'HOM'"
    :class="['pickup-location', { 'pickup-location--alt': nameLangue !== 'fr' }]"
  >
    <div
      v-if="pickupLocationInfo"
      :class="[
        'pickup-location__container',
        { 'pickup-location--border-hidden': hasStepFiveEvent },
        { 'pickup-location__container--alt': nameLangue !== 'fr' },
      ]"
    >
      <div
        :class="[
          'pickup-location__text-container',
          { 'pickup-location__text-container--alt': nameLangue !== 'fr' },
        ]"
      >
        <div class="pickup-location__sub-container">
          <div class="pickup-location__name">
            <span class="pickup-location__label">{{
              $t('tracking.pickupLocation.areaLabel')
            }}</span>
            <span class="pickup-location__value">{{ locationName }}</span>
          </div>
          <div class="pickup-location__address">
            <span>{{ address }}</span>
          </div>
        </div>

        <div class="pickup-location__status-container">
          <span :class="['pickup-location__status-container--info', statusClass]">{{
            WithdrawalStatus
          }}</span>
          <span class="pickup-location__status-container--closing"
            >{{ $t('tracking.pickupLocation.closingLabel') }} {{ closingTime }}</span
          >
        </div>
      </div>

      <div
        :class="[
          'pickup-location__more-info',
          { 'pickup-location__more-info--alt': nameLangue !== 'fr' },
        ]"
      >
        <LockerDetails :details="pickupLocationInfo" />
      </div>
    </div>

    <div
      v-if="nameLangue === 'fr' && shouldDisplayBanner"
      :class="[
        'pickup-location__withdrawal-banner',
        { 'pickup-location__withdrawal-banner--hidden': hasStepFiveEvent },
      ]"
    >
      <div class="pickup-location__withdrawal-banner--text-container">
        <div class="pickup-location__withdrawal-banner--title" @click="toggleBannerContent">
          {{ $t('tracking.info.withdrawalBannerTitle') }}
          <span
            v-if="isMobile"
            :class="{
              'rotated-icon rotated-icon--open': isBannerOpen,
              'rotated-icon rotated-icon--closed': !isBannerOpen,
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M2.97528 10.6665L8.30862 5.33317L13.6419 10.6665"
                stroke="#222222"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </span>
        </div>
        <div v-if="isBannerOpen || !isMobile" class="pickup-location__withdrawal-content">
          <p v-if="hasStepFourEvent" class="pickup-location__withdrawal-banner-text">
            {{ $t('tracking.info.withdrawalBannerFind') }}
            <strong>{{ $t('tracking.info.withdrawalBannerMail') }}</strong>
            {{ $t('tracking.info.withdrawalBannerSend') }}
            <strong>{{ $t('tracking.info.withdrawalBannerBy') }}</strong>
          </p>
          <p v-else class="pickup-location__withdrawal-banner-text">
            {{ $t('tracking.info.withdrawalBannerFindND') }}
            <strong>{{ $t('tracking.info.withdrawalBannerMailND') }}</strong>
            {{ $t('tracking.info.withdrawalBannerSendND') }}
            <strong>{{ $t('tracking.info.withdrawalBannerByND') }}</strong>
            <br /><br />
            {{ $t('tracking.info.withdrawalBannerND') }}
            <br /><br />
            <strong>{{ $t('tracking.info.withdrawalBannerExtra1ND') }}</strong>
            {{ $t('tracking.info.withdrawalBannerExtra2ND') }}
          </p>

          <div class="pickup-location__withdrawal-banner-content-container">
            <button
              @click="shareCode"
              class="pickup-location__withdrawal-banner--btn btn btn-primary"
            >
              <svg width="16" height="25" viewBox="0 0 16 25" xmlns="http://www.w3.org/2000/svg">
                <path
                  class="icon-path"
                  id="Vector"
                  d="M13.25 0.529297H2.75C2.15326 0.529297 1.58097 0.76635 1.15901 1.18831C0.737053 1.61026 0.5 2.18256 0.5 2.7793L0.5 22.2793C0.5 22.876 0.737053 23.4483 1.15901 23.8703C1.58097 24.2922 2.15326 24.5293 2.75 24.5293H13.25C13.8467 24.5293 14.419 24.2922 14.841 23.8703C15.2629 23.4483 15.5 22.876 15.5 22.2793V2.7793C15.5 2.18256 15.2629 1.61026 14.841 1.18831C14.419 0.76635 13.8467 0.529297 13.25 0.529297ZM8 23.0293C7.80328 23.0292 7.60851 22.9903 7.42682 22.9149C7.24512 22.8395 7.08006 22.729 6.94105 22.5898C6.6603 22.3087 6.50273 21.9276 6.503 21.5303C6.50313 21.3336 6.54201 21.1388 6.61741 20.9571C6.69281 20.7754 6.80327 20.6104 6.94246 20.4713C7.22358 20.1906 7.60471 20.033 8.002 20.0333C8.39929 20.0336 8.78021 20.1916 9.06095 20.4728C9.34169 20.7539 9.49926 21.135 9.499 21.5323C9.49873 21.9296 9.34066 22.3105 9.05954 22.5912C8.77842 22.872 8.39729 23.0296 8 23.0293ZM13.25 17.9693C13.249 18.1175 13.1896 18.2593 13.0848 18.3641C12.98 18.4689 12.8382 18.5282 12.69 18.5293H3.312C3.16348 18.5293 3.02104 18.4703 2.91602 18.3653C2.811 18.2603 2.752 18.1178 2.752 17.9693V3.3423C2.752 3.19378 2.811 3.05134 2.91602 2.94632C3.02104 2.8413 3.16348 2.7823 3.312 2.7823H12.686C12.8342 2.78334 12.976 2.84268 13.0808 2.94747C13.1856 3.05227 13.245 3.1941 13.246 3.3423L13.25 17.9693Z"
                  fill="white"
                />
              </svg>
              {{
                hasStepFourEvent
                  ? $t('tracking.info.deliveredText')
                  : $t('tracking.info.defaultText')
              }}
            </button>
            <a @click.prevent="scrollToBlocapp" class="pickup-location__withdrawal-banner--link">{{
              $t('tracking.info.applinkLabel')
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LockerDetails from '../LockerDetails/LockerDetails.vue';
import { mapState } from 'vuex';

export default {
  name: 'PickupLocationInfo',
  components: {
    LockerDetails,
  },
  props: {
    locationName: String,
    closingTime: String,
    address: String,
    pickupLocationInfo: Object,
    status: String,
  },
  data() {
    return {
      isBannerOpen: false,
      isMobile: window.innerWidth < 768,
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    ...mapState(['nameLangue', 'fiveStepsTracking', 'deliveryMode']),
    hasStepFourEvent() {
      return this.fiveStepsTracking?.[4]?.Evenement
        ? Object.keys(this.fiveStepsTracking[4].Evenement).length > 0
        : false;
    },

    hasStepFiveEvent() {
      return this.fiveStepsTracking?.[5]?.Evenement
        ? Object.keys(this.fiveStepsTracking[5].Evenement).length > 0
        : false;
    },

    shouldDisplayBanner() {
      return this.hasStepFourEvent || !this.hasStepFiveEvent;
    },
    withdrawalStatus() {
      return this.isCurrentlyOpen()
        ? this.$t('tracking.pickupLocation.opened')
        : this.$t('tracking.pickupLocation.closed');
    },
    statusClass() {
      return this.isCurrentlyOpen() ? 'open' : 'closed';
    },
    hasFiveStepsTracking() {
      const steps = this.fiveStepsTracking;
      return steps && Object.keys(steps).length > 3;
    },
  },
  methods: {
    shareCode() {
      window.open(
        'https://8a9s.adj.st?adj_t=1gjvjhl6_1gw0tj2u&adj_fallback=https%3A%2F%2Fwww.mondialrelay.fr%2Fapplication-mobile%2F&adj_redirect_macos=https%3A%2F%2Fwww.mondialrelay.fr%2Fapplication-mobile%2F',
        '_blank'
      );
    },
    toggleBannerContent() {
      if (this.isMobile) {
        this.isBannerOpen = !this.isBannerOpen;
      }
    },
    scrollToBlocapp() {
      const section = document.getElementById('blocapp');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    getCurrentTime() {
      const d = new Date();
      const h = String(d.getHours()).padStart(2, '0');
      const m = String(d.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    },
    isCurrentlyOpen() {
      if (!this.closingTime || !/^\d{2}:\d{2}$/.test(this.closingTime)) {
        return false;
      }

      const now = this.getCurrentTime();
      if (!/^\d{2}:\d{2}$/.test(now)) return false;

      return now < this.closingTime;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>

<style scoped lang="scss">
@import './PickupLocationInfo.scss';
</style>
